import React from "react";
import { PageContainer } from "lib/components/PageContainer";
import { ErrorHandledRoute } from "lib/components/ErrorHandledRoute";

import { Dashboard } from "./dashboard";
import { Tags } from "./tags";
import { useFetch, fetchData } from "lib/helpers/fetchData";
import { getApiUrl } from "lib/helpers/getApiUrl";

const loadTags = async ({ apiRoot }) => {
  return await fetchData(`${apiRoot}/tags`);
};

export const TagsContext = React.createContext({});

export const Phish = () => {
  const tagsData = useFetch(loadTags, { apiRoot: getApiUrl("PHISH_API_V2") });
  const routes = [{ name: "Tags", link: "/phish/tags" }];

  return (
    <TagsContext.Provider value={tagsData}>
      <PageContainer name="Phish" link="/phish" routes={routes}>
        <ErrorHandledRoute path="/phish/tags" component={Tags} />
        <ErrorHandledRoute path="/phish" component={Dashboard} />
      </PageContainer>
    </TagsContext.Provider>
  );
};
